<!-- Hero Section -->
<section class="relative min-h-[90vh] flex items-center overflow-hidden">
  <!-- Background Image -->
  <div class="absolute inset-0 z-0">
    <img
      src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&h=800&fit=crop"
      alt="Digital Technology Background"
      class="w-full h-full object-cover"
    />
    <div class="absolute inset-0 bg-gradient-to-br from-primary-900/90 via-primary-800/85 to-primary-700/90"></div>
  </div>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="text-white">
        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Xpress<span class="text-primary-200">SMS</span>
        </h1>
        <h2 class="text-2xl md:text-3xl font-semibold mb-4 text-primary-200">Bulk SMS & WhatsApp Marketing Solutions</h2>
        <p class="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
          Reach Your Customers Instantly with High-Delivery SMS & WhatsApp Marketing. Whether you're a startup, educational institution, e-commerce business, healthcare provider, or enterprise.
        </p>
        <div class="flex flex-col sm:flex-row gap-4">
          <a [href]="consultationUrl" target="_blank" rel="noopener" class="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold hover:bg-primary-50 hover:text-primary-700 transition-all duration-300 text-center shadow-lg hover:shadow-xl text-lg">Get a Free Consultation</a>
          <button type="button" (click)="openBrochureModal()" class="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/10 transition-all duration-300 text-center text-lg">Download Brochure</button>
        </div>
      </div>
      <div class="flex justify-center">
        <img src="assets-landing/xpress1.jpeg" alt="Xpress SMS - Send Smarter, Grow Faster" class="rounded-2xl shadow-2xl max-w-full h-auto" />
      </div>
    </div>
  </div>
  <!-- Wave Bottom -->
  <div class="absolute bottom-0 left-0 right-0 z-10">
    <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white"/>
    </svg>
  </div>
</section>

<!-- Contact Form -->
<section id="contact-form" class="py-20 bg-gray-50">
  <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-10">
      <h2 class="section-title">Get in Touch</h2>
      <p class="section-subtitle">Tell us about your messaging needs and our team will get back to you with the best pricing.</p>
    </div>
    <div class="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8">
      <!-- HubSpot form target; rendered by the embed script loaded in landing.ts -->
      <div class="hs-form-frame" data-region="eu1" data-form-id="f4d49da2-a1a2-4c2d-be25-1b4a3345f1dc" data-portal-id="24997730"></div>
    </div>
  </div>
</section>

<!-- Why Choose Xpress SMS -->
<section class="py-20 bg-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-16">
      <h2 class="section-title">Why Choose Xpress SMS?</h2>
      <p class="section-subtitle">Trusted by thousands of businesses for fast, reliable, and affordable messaging solutions.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">High Priority SMS Delivery</p>
          <p class="text-gray-600 text-sm">@ Just 8 Paisa/SMS</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">WhatsApp Messaging</p>
          <p class="text-gray-600 text-sm">@ Just 14 Paisa/Message</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">Fast, Secure & Reliable</p>
          <p class="text-gray-600 text-sm">SMS Routes</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">Free DLT Registration</p>
          <p class="text-gray-600 text-sm">Support</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">Real-Time Delivery Reports</p>
          <p class="text-gray-600 text-sm">Track every message</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">Easy-to-Use Dashboard</p>
          <p class="text-gray-600 text-sm">Simple & intuitive</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">API Integration</p>
          <p class="text-gray-600 text-sm">For Websites & Applications</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">Dedicated Customer Support</p>
          <p class="text-gray-600 text-sm">Always here to help</p>
        </div>
      </div>
      <div class="flex items-start gap-4 p-5 rounded-xl bg-primary-50 border border-primary-100">
        <span class="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-full flex items-center justify-center font-bold text-sm">&#10003;</span>
        <div>
          <p class="font-semibold text-gray-900">Competitive Pricing</p>
          <p class="text-gray-600 text-sm">& Bulk Discounts</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Channel Hub Image Section -->
<section class="py-20 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800">
  <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">Multi-Channel Messaging Hub</h2>
    <p class="text-lg text-white/80 mb-10">Connect with your customers across SMS, WhatsApp, Voice, and more — all from one platform.</p>
    <img src="assets-landing/xpress.jpeg" alt="Xpress SMS Multi-Channel Hub - SMS, WhatsApp, Voice" class="rounded-2xl shadow-2xl mx-auto max-w-full h-auto" />
  </div>
</section>

<!-- Contact Form -->
<section class="py-20 bg-white">
  <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-10">
      <h2 class="section-title">Request a Free Demo</h2>
      <p class="section-subtitle">Share your details and our team will reach out with the best pricing and a free consultation.</p>
    </div>
    <div class="bg-gray-50 rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8">
      <!-- HubSpot form target; rendered by the embed script loaded in landing.ts -->
      <div class="hs-form-frame" data-region="eu1" data-form-id="f4d49da2-a1a2-4c2d-be25-1b4a3345f1dc" data-portal-id="24997730"></div>
    </div>
  </div>
</section>

<!-- Our Services -->
<section class="py-20 bg-gray-50">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-16">
      <h2 class="section-title">Our Services</h2>
      <p class="section-subtitle">Comprehensive messaging solutions tailored for every business need.</p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      <div *ngFor="let service of services" class="card group overflow-hidden hover:-translate-y-2 transition-all duration-300 p-6">
        <div class="w-16 h-16 bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl flex items-center justify-center mb-4 shadow-lg">
          <svg *ngIf="service.icon === 'transactional'" class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
          <svg *ngIf="service.icon === 'promotional'" class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" /></svg>
          <svg *ngIf="service.icon === 'whatsapp'" class="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
          <svg *ngIf="service.icon === 'dlt'" class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
          <svg *ngIf="service.icon === 'voice'" class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
          <svg *ngIf="service.icon === 'api'" class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg>
          <svg *ngIf="service.icon === 'sim'" class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>
          <svg *ngIf="service.icon === 'school'" class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" /></svg>
        </div>
        <h3 class="text-xl font-bold text-gray-900 mb-1">{{ service.title }}</h3>
        <p class="text-sm text-primary-600 font-medium mb-3">{{ service.subtitle }}</p>
        <p class="text-gray-600 leading-relaxed">{{ service.description }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Reseller Program -->
<section class="py-20 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 text-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div>
        <h2 class="text-3xl md:text-4xl font-bold mb-4">Reseller Program</h2>
        <p class="text-lg text-white/80 mb-8">Start your own SMS business with our reseller solutions.</p>
        <div class="space-y-4">
          <div class="flex items-center gap-3">
            <span class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
            </span>
            <span class="text-lg">White Label Solutions</span>
          </div>
          <div class="flex items-center gap-3">
            <span class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
            </span>
            <span class="text-lg">Attractive Margins</span>
          </div>
          <div class="flex items-center gap-3">
            <span class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
            </span>
            <span class="text-lg">Dedicated Support</span>
          </div>
          <div class="flex items-center gap-3">
            <span class="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
            </span>
            <span class="text-lg">Recurring Income Opportunities</span>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <h3 class="text-2xl font-bold mb-4">Become a Reseller</h3>
          <p class="text-white/80 mb-6">Earn money by reselling our SMS & WhatsApp services to your clients.</p>
          <a [href]="consultationUrl" target="_blank" rel="noopener" class="inline-block bg-white text-primary-600 font-semibold px-8 py-3 rounded-lg hover:bg-primary-50 hover:text-primary-700 transition-all duration-300 shadow-lg">Get Started</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Why SMS Marketing -->
<section class="py-20 bg-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-16">
      <h2 class="section-title">Why SMS Marketing?</h2>
      <p class="section-subtitle">SMS remains the most effective direct communication channel for businesses.</p>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
      <div *ngFor="let reason of smsReasons" class="text-center p-6 rounded-xl bg-gray-50 border border-gray-100">
        <p class="text-3xl font-bold bg-gradient-to-r from-primary-600 to-primary-700 bg-clip-text text-transparent mb-2">{{ reason.stat }}</p>
        <p class="text-sm text-gray-600 font-medium">{{ reason.label }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Industries We Serve -->
<section class="py-20 bg-gray-50">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="text-center mb-16">
      <h2 class="section-title">Industries We Serve</h2>
      <p class="section-subtitle">Trusted across diverse sectors for reliable messaging solutions.</p>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
      <div *ngFor="let industry of industries" class="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm border border-gray-100">
        <span class="w-3 h-3 bg-primary-600 rounded-full flex-shrink-0"></span>
        <span class="text-gray-700 font-medium">{{ industry }}</span>
      </div>
    </div>
  </div>
</section>

<!-- Request Demo Form -->
<section id="demo-form" class="py-20 relative overflow-hidden">
  <div class="absolute inset-0 z-0">
    <img
      src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&h=800&fit=crop"
      alt="Background"
      class="w-full h-full object-cover"
    />
    <div class="absolute inset-0 bg-gradient-to-br from-primary-900/90 via-primary-800/85 to-primary-700/90"></div>
  </div>
  <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
    <div class="text-center mb-10">
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">Get Started Today</h2>
      <p class="text-lg text-white/80">Fill out the form below and our team will contact you with the best pricing and a free consultation.</p>
    </div>

    <div class="bg-white rounded-2xl shadow-2xl p-6 sm:p-8">
      <h3 class="text-2xl font-bold text-center text-gray-900 mb-8">Request a Free Demo</h3>
      <!-- HubSpot form target; rendered by the embed script loaded in landing.ts -->
      <div class="hs-form-frame" data-region="eu1" data-form-id="f4d49da2-a1a2-4c2d-be25-1b4a3345f1dc" data-portal-id="24997730"></div>
    </div>
  </div>
</section>

<!-- Contact CTA -->
<section class="py-12 bg-gradient-to-r from-primary-600 to-primary-700 text-white">
  <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h2 class="text-2xl md:text-3xl font-bold mb-4">Contact Us Today</h2>
    <p class="text-xl mb-2">
      <a href="tel:+919020719103" class="hover:text-primary-200 transition-colors">Call: +91 9020719103</a>
    </p>
    <p class="text-lg text-white/80">Start reaching your customers instantly with Xpress SMS</p>
  </div>
</section>

<!-- Brochure Download – OTP Modal -->
<div *ngIf="showBrochureModal" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" (click)="closeBrochureModal()"></div>
  <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
    <button type="button" (click)="closeBrochureModal()" aria-label="Close"
      class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
    </button>

    <!-- Step 1: Enter mobile -->
    <div *ngIf="brochureStep === 'mobile'">
      <div class="w-14 h-14 bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl flex items-center justify-center mb-4 shadow-lg">
        <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
      </div>
      <h3 class="text-2xl font-bold text-gray-900 mb-2">Download Brochure</h3>
      <p class="text-gray-600 mb-6">Enter your mobile number and we'll send you an OTP to verify before downloading.</p>
      <form (ngSubmit)="sendOtp()">
        <label for="brochure-mobile" class="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
        <div class="flex">
          <span class="inline-flex items-center px-4 rounded-l-lg border border-r-0 border-gray-300 bg-gray-50 text-gray-700 font-medium">+91</span>
          <input type="tel" id="brochure-mobile" [(ngModel)]="brochureMobile" name="brochureMobile" required
            inputmode="numeric" maxlength="10" autocomplete="tel-national"
            (input)="onMobileInput($event)" (keypress)="blockNonNumeric($event)" (paste)="onMobilePaste($event)"
            class="w-full px-4 py-3 rounded-r-lg border border-gray-300 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            placeholder="10-digit number" />
        </div>
        <p *ngIf="otpError" class="text-red-600 text-sm mt-2">{{ otpError }}</p>
        <button type="submit" [disabled]="isSendingOtp" class="w-full btn-primary py-4 mt-6 text-lg disabled:opacity-60">
          {{ isSendingOtp ? 'Sending OTP...' : 'Send OTP' }}
        </button>
      </form>
    </div>

    <!-- Step 2: Enter OTP -->
    <div *ngIf="brochureStep === 'otp'">
      <div class="w-14 h-14 bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl flex items-center justify-center mb-4 shadow-lg">
        <svg class="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
      </div>
      <h3 class="text-2xl font-bold text-gray-900 mb-2">Enter OTP</h3>
      <p class="text-gray-600 mb-6">We've sent a 6-digit code to <span class="font-semibold text-gray-900">+91 {{ brochureMobile }}</span>.</p>
      <form (ngSubmit)="verifyOtp()">
        <label for="brochure-otp" class="block text-sm font-medium text-gray-700 mb-1">One-Time Password</label>
        <input type="text" inputmode="numeric" maxlength="6" id="brochure-otp" [(ngModel)]="enteredOtp" name="brochureOtp" required
          (keypress)="blockNonNumeric($event)"
          class="w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 tracking-[0.5em] text-center text-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="••••••" />
        <p *ngIf="otpError" class="text-red-600 text-sm mt-2">{{ otpError }}</p>
        <button type="submit" [disabled]="isVerifyingOtp" class="w-full btn-primary py-4 mt-6 text-lg disabled:opacity-60">
          {{ isVerifyingOtp ? 'Verifying...' : 'Verify & Download' }}
        </button>
      </form>
      <div class="flex items-center justify-between mt-4 text-sm">
        <button type="button" (click)="brochureStep = 'mobile'; otpError = ''" class="text-gray-500 hover:text-gray-700">Change number</button>
        <button type="button" (click)="sendOtp()" [disabled]="isSendingOtp || resendCooldown > 0" class="text-primary-600 font-medium hover:text-primary-700 disabled:opacity-60">
          {{ resendCooldown > 0 ? 'Resend OTP in ' + resendCooldown + 's' : (isSendingOtp ? 'Sending...' : 'Resend OTP') }}
        </button>
      </div>
    </div>
  </div>
</div>
